import Rule from '@elem/compPage/Rule';
import { useRouter } from 'next/router';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { useLang } from '@/i18n';
import withCountryRedirect from '@/components/WithIPRedirect';

const whiteLocaleList = ['us', 'ca', 'uk', 'au', 'za', 'eu', 'de', 'fr', 'it', 'es', 'jp', 'sa', 'cn', 'tw', 'kr', 'br', 'mx'];
function Page({ SEO }: any) {
    const router = useRouter();
    const { t } = useLang('rule');

    return (
        <PageLayout theme="white">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={router.locale} list={whiteLocaleList} pathname={'rule'} />
            <Rule />
        </PageLayout>
    );
}

export default withCountryRedirect(Page);

// export async function getServerSideProps({ locale }: any) {
//     // 非白名单404
//     if (!whiteLocaleList.includes(locale as string)) {
//         return redirectTo404();
//     }
//     return {
//         props: {},
//     };
// }
